"use strict";

angular.module('PatientApp').factory('OverlayService', function (VuexStore) {
  return {
    show: function show(key, clickCallback) {
      return VuexStore.dispatch('showOverlay', {
        key: key,
        clickCallback: clickCallback
      });
    },
    hide: function hide(key) {
      return VuexStore.dispatch('hideOverlay', key);
    },
    clicked: function clicked() {
      return VuexStore.dispatch('clickOverlay');
    },
    isOverlayVisible: function isOverlayVisible() {
      return VuexStore.state.AppStore.isOverlayVisible;
    }
  };
});